import { flatten } from 'lodash'

/**
 * Constrói o objeto de rotas no formato esperado pelo vue-router
 *
 * @param {Object} pageLayout
 * @param {Array<Object>} rootRoutes
 * @param {Array<Object>} noLayoutRoutes
 * @returns {Object} Objeto contendo as rotas para a inicialização do vue-router
 */
export function createRouterConfig(pageLayout, rootRoutes, noLayoutRoutes) {
  const routerConfig = {
    routes: [
      {
        path: '/',
        component: pageLayout,
        children: rootRoutes
      }
    ]
  }

  if (noLayoutRoutes) {
    const extraRoutes = flatten(noLayoutRoutes)
    extraRoutes.forEach(item => routerConfig.routes.push(item))
  }
  return routerConfig
}
